import { HeaderIcon } from "./AppHeader";
import "./planos.css";

/* Card do plano único — componente compartilhado entre EscolherPlano.jsx
   (tela cheia pós-cadastro), Configuracoes.jsx (aba Assinatura) e
   PlanoExpirado.jsx, pra preço e regras não divergirem entre as telas como
   aconteceu antes (valor fixo num lugar só). O preço vem do painel admin via
   usePrecos; enquanto não chega, mostra "—" em vez de um valor que pode não
   ser o cobrado. */

const FEATURES_NORMAL = [
  "Pedidos, financeiro e clientes",
  "Agenda, filamentos e impressoras",
  "Calculadora de preço e relatórios",
  "PDV completo (caixa integrado)",
  "Loja online publicada (site)",
];

const FEATURES_TRIAL = [
  "Todos os recursos do app liberados",
  "Sem cartão de crédito",
  "Nada é cobrado no fim do teste",
];

/* Planos pagos não-trial — usado pra saber quem tem assinatura ativa/vencível.
   "annual" fica aqui só por compatibilidade com quem assinou o anual antes de
   virar plano único mensal; não é mais oferecido pra assinatura nova. */
export const PLANOS_PAGOS = ["monthly", "annual"];

const reais = valor => valor == null ? "—" : Number(valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Check() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7" /></svg>;
}

function Presente() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 12v9H4v-9 M2.5 7.5h19V12h-19z M12 21V7.5 M12 7.5H7.8a2.3 2.3 0 1 1 0-4.6C10.8 2.9 12 7.5 12 7.5z M12 7.5h4.2a2.3 2.3 0 1 0 0-4.6C13.2 2.9 12 7.5 12 7.5z" />
  </svg>;
}

function Botao({ carregando, cheio, children, ...props }) {
  return <button type="button" className={`plano-cta${cheio ? " plano-cta--cheio" : ""}`} aria-busy={carregando || undefined} {...props}>
    {carregando ? <><span className="plano-spin" aria-hidden="true" />Abrindo…</> : children}
  </button>;
}

// precoTexto: preço já formatado por quem cobra (a Google Play, no app Android)
export default function PlanCards({ precos, jaUsouTrial, assinando, onTrial, onAssinar, compact = false, precoTexto = null, showFeatures = !compact }) {
  const Titulo = compact ? "h3" : "h2";
  const grade = ["plano-grade", jaUsouTrial && "plano-grade--uma", compact && "plano-grade--compacta"].filter(Boolean).join(" ");

  return (
    <div className={grade}>
      {!jaUsouTrial && (
        <article className="plano-card plano-card--trial" aria-labelledby="plano-trial-titulo">
          <div className="plano-card-topo">
            <span className="plano-icone"><Presente /></span>
            <div className="plano-card-titulo">
              <Titulo id="plano-trial-titulo">Teste grátis</Titulo>
              {!compact && <p>Use tudo antes de decidir.</p>}
            </div>
            {!compact && <span className="plano-selo">Sem cartão</span>}
          </div>
          <div className="plano-preco"><strong>Grátis</strong><span>por 30 dias</span></div>
          {!compact && <ul className="plano-lista">{FEATURES_TRIAL.map(f => <li key={f}><Check />{f}</li>)}</ul>}
          <Botao cheio carregando={assinando === "trial"} disabled={!!assinando} onClick={onTrial}>Começar grátis</Botao>
        </article>
      )}

      <article className="plano-card" aria-labelledby="plano-pro-titulo">
        <div className="plano-card-topo">
          <span className="plano-icone"><HeaderIcon name="cube" size={22} /></span>
          <div className="plano-card-titulo">
            <Titulo id="plano-pro-titulo">Print Control</Titulo>
            {showFeatures && <p>Os recursos para sua produção crescer.</p>}
          </div>
        </div>
        <div className="plano-preco"><strong>{precoTexto || `R$ ${reais(precos.precoMensal)}`}</strong><span>/mês</span></div>
        {showFeatures && <ul className="plano-lista">{FEATURES_NORMAL.map(f => <li key={f}><Check />{f}</li>)}</ul>}
        <Botao cheio={!!jaUsouTrial} carregando={assinando === "monthly"} disabled={!!assinando} onClick={() => onAssinar("monthly")}>Assinar</Botao>
      </article>
    </div>
  );
}
